import {formsState, formTableRow} from "../types/index"

export const initialState:formsState = {
    loading: false,    
    error: "",
    formData: [],
    formState: {
        fileName:"",
        formDesc:"",
        formGroup:0,
        sortorder:0,
    },
    pendingForm: {
        fileName:"",
        formDesc:"",
        formGroup:0,
        sortorder:0,
    },
    isAddModalOpen: false,
    uploadedFile: null,
    uploadedFileError: ""
}






export default initialState
